export enum ProcessType {
    PersonalGuarantee = 'personal-guarantee',
    BankFinancialConnection = 'bank-financial-connection',
    InsuranceCover = 'insurance-cover',
    CreditScore = 'credit-score',
    AnnualBankRevenue = 'annual-bank-revenue',
    MinimalAnnualBankRevenue = 'minimal-annual-bank-revenue',
    NSFOverdraft = 'nsf-overdraft',
    NegativeBalanceDays = 'negative-balance-days',
    BusinessVerification = 'business-verification',
    BusinessStartDate = 'business-start-date',
    AccountBalance = 'account.balance.process',
    AvailableBankActivity = 'available.bank.activity.process',
    BankRevenueToRequestedCreditRatio = 'bank-revenue.to.requested-credit.ratio.process',
    DebtRepaymentToMonthlyBankRevenueRatio = 'debt-repayment.to.monthly.bank-revenue.ratio.process',
    DebtAmount = 'debt.amount.process',
    NetProfit = 'net.profit.process',
    BondRating = 'bond-rating',
    Reliability = 'reliability',
    IdentityVerification = 'identity-verification',
    TransactionsPerMonth = 'transactions.per-month.process',
}
